import { defineMessages } from 'react-intl';
export default defineMessages({
    cancelError: {
        id: 'network.cancelError',
        defaultMessage: 'Request has been cancelled',
    },
    connectionError: {
        id: 'network.connectionError',
        defaultMessage: 'Server not available',
    },
    networkError: {
        id: 'network.networkError',
        defaultMessage: 'Network not available',
    },
    serverError: {
        id: 'network.serverError',
        defaultMessage: 'Something went wrong...',
    },
    timeoutError: {
        id: 'network.timeoutError',
        defaultMessage: 'Connection timeout',
    },
    unknownError: {
        id: 'network.unknownError',
        defaultMessage: 'Unknown Error',
    },
});
